var link_viewer_default = {
  "fontElementMap": "_1Jptl",
  "link": "W7POc",
  "linkInEditor": "_4up9t",
  "linkInViewer": "I8gJq",
  "toolbarUrlContainer": "_2eQBg",
  "toolbarUrl": "cmWl2",
  "toolbarUrlAnchor": "BJjFQ"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
